import React from 'react';
import { useStageClickedOnListener } from 'state/canvas/stage-clicked-on';
import { useLinkUnselectedListener } from 'state/canvas/selected-link';
import { SurfaceNodePointsTo } from 'graphql/types';

export interface EdgeListenersProps {
  onStageClick(): void;
  link: SurfaceNodePointsTo;
}

const defaultProps = {};

function EdgeListeners(props: EdgeListenersProps) {
  useStageClickedOnListener(props.onStageClick);

  useLinkUnselectedListener(props.link, props.onStageClick);

  return null;
}

EdgeListeners.defaultProps = defaultProps;

export default EdgeListeners;
